import { lazy } from 'react';

// const DataGrid = lazy(() => import('../../views/DataGrid'));
// const ProjectSetting = lazy(() => import('../../views/ProjectSetting'));
const ProjectSetting = lazy(() => import('../../views/ProjectSetting'));

const ProjectSettingRoutes = [
    {
        path: '/settings/project-setting',
        element: <ProjectSetting />
    }
];

export default ProjectSettingRoutes;
